$(".realization").off('click').on('click', function (e) {

  $('.realization-popup').addClass("active");
  $(".realization-popup .popup-content .post__content").html("<div id='loading'></div>");
  $(".realization-popup .popup-content").load("/projekty/" + $(this).attr('id') + " #post__content");
  current = (this);
  prev = (this);
  next = (this);
  if (current.nextElementSibling) {
    next = current.nextElementSibling;
  } else {
    $('.realization-popup .popup__next').css("visibility", "hidden");
  }
  if (current.previousElementSibling) {
    prev = current.previousElementSibling;
  } else {
    $('.realization-popup .popup__prev').css("visibility", "hidden");
  }

  $('.realization-popup .popup__prev').off('click').on('click', function (e) {
    prev = current.previousElementSibling;
    $(".realization-popup .popup-content .post__content").html("<div id='loading'></div>");
    $(".realization-popup .popup-content").load("/projekty/" + $(prev).attr('id') + " #post__content");
    current = prev;
    next = current.nextElementSibling;
    if (current.nextElementSibling) {
      $('.realization-popup .popup__next').css("visibility", "visible");
    } else {
      $('.realization-popup .popup__next').css("visibility", "hidden");
    }
    if (current.previousElementSibling) {
      $('.realization-popup .popup__prev').css("visibility", "visible");
    } else {
      $('.realization-popup .popup__prev').css("visibility", "hidden");
    }
  });

  $('.realization-popup .popup__next').off('click').on('click', function (e) {
    next = current.nextElementSibling;
    $(".realization-popup .popup-content .post__content").html("<div id='loading'></div>");
    $(".realization-popup .popup-content").load("/projekty/" + $(next).attr('id') + " #post__content");
    current = next;
    prev = current.previousElementSibling;

    if (current.nextElementSibling) {
      $('.realization-popup .popup__next').css("visibility", "visible");
    } else {
      $('.realization-popup .popup__next').css("visibility", "hidden");
    }
    if (current.previousElementSibling) {
      $('.realization-popup .popup__prev').css("visibility", "visible");
    } else {
      $('.realization-popup .popup__prev').css("visibility", "hidden");
    }
  });
});


